export default "__VITE_ASSET__Dam2dH7x__"